/**
 * H5 后管侧栏菜单（非教培一级项）
 * key 与 sys_user.h5_admin_menus / H5AdminUserVo.h5AdminMenus 对齐
 */

export const H5_ADMIN_MENU_KEYS = {
  HOME: 'home',
  REDBOOK: 'redbook',
  // signs_points_admin：仅小程序店员积分管理权限键，H5 不再提供页面
  SCHOOLS_PLATFORM_ORGS: 'schools_platform_orgs',
  SCHOOLS_DASHBOARD: 'schools_dashboard',
  SCHOOLS_SUBJECT: 'schools_subject',
  SCHOOLS_COURSE: 'schools_course',
  SCHOOLS_CLASS: 'schools_class',
  SCHOOLS_SCHEDULE: 'schools_schedule',
  SCHOOLS_STUDENT: 'schools_student',
  SCHOOLS_ENROLL: 'schools_enroll',
  SCHOOLS_ATTENDANCE: 'schools_attendance',
  SCHOOLS_LEAVE: 'schools_leave',
  SCHOOLS_TEACHER: 'schools_teacher',
  SCHOOLS_ROOM: 'schools_room',
  SCHOOLS_NOTICE: 'schools_notice',
  SCHOOLS_SETTING: 'schools_setting'
}

export const h5AdminMenus = [
  { key: H5_ADMIN_MENU_KEYS.HOME, index: '/admin/home', title: '首页', icon: 'el-icon-s-home' },
  { key: H5_ADMIN_MENU_KEYS.REDBOOK, index: '/admin/redbook', title: '小红书活动', icon: 'el-icon-document' }
]

/** 兼容旧缓存：无 menus 时默认首页+小红书 */
const DEFAULT_MENUS = [H5_ADMIN_MENU_KEYS.HOME, H5_ADMIN_MENU_KEYS.REDBOOK]

function expandMenuKeys(keys) {
  const out = []
  const seen = new Set()
  ;(keys || []).forEach((raw) => {
    const key = String(raw || '').trim()
    if (!key) return
    if (seen.has(key)) return
    // 已下线页面权限忽略
    if (
      key === 'seal' ||
      key === 'seal_mgmt' ||
      key === 'seal_manage' ||
      String(key).indexOf('seal_') === 0 ||
      key === 'signs' ||
      String(key).indexOf('signs_') === 0
    ) {
      return
    }
    seen.add(key)
    out.push(key)
  })
  return out
}

export function resolveH5AdminMenuKeys(userInfo) {
  if (!userInfo) {
    return expandMenuKeys(DEFAULT_MENUS.slice())
  }
  // 兼容 camelCase / snake_case，以及登录缓存里偶发的字符串
  const raw = userInfo.h5AdminMenus != null
    ? userInfo.h5AdminMenus
    : userInfo.h5_admin_menus
  let keys
  if (Array.isArray(raw) && raw.length) {
    keys = raw.map(item => String(item).trim()).filter(Boolean)
  } else if (typeof raw === 'string' && raw.trim()) {
    keys = raw.split(/[,，;\s]+/).map(item => item.trim()).filter(Boolean)
  } else {
    keys = DEFAULT_MENUS.slice()
  }
  return expandMenuKeys(keys)
}

export function filterH5AdminMenus(userInfo) {
  const allowed = new Set(resolveH5AdminMenuKeys(userInfo))
  return h5AdminMenus.filter(item => allowed.has(item.key))
}

export function resolveH5AdminActiveMenu(path) {
  if (!path) return path
  return path
}

export function hasH5AdminMenu(userInfo, menuKey) {
  if (!menuKey) return true
  return resolveH5AdminMenuKeys(userInfo).indexOf(menuKey) >= 0
}

/** 是否拥有任一教培二级菜单权限 */
export function hasAnySchoolsH5AdminMenu(userInfo) {
  return resolveH5AdminMenuKeys(userInfo).some(key => String(key).indexOf('schools_') === 0)
}
